import React from 'react';

export const FavListContext = React.createContext({
   // favouriteList: [],
   // setFavouriteList: () => {},
   favToLs:[],
   setFavToLs: ()=> {},
});